import React, { useState, createContext, useContext } from 'react';
import { getIdToken } from 'firebase/auth';
import { auth } from '../../firebase';

export const AppStateContext = createContext();

export const AppStateStore = ({ children }) => {
  const [customLegendConfig, setCustomLegendConfig] = useState([]);

  const [isCustomLegendOpen, setIsCustomLegendOpen] = useState(false);

  const [apiResponse, setApiResponse] = useState([]);

  const [chatLoader, setChatLoader] = useState(false);

  const [currConvId, setCurrConvId] = useState(null);

  const [customSqlData, setCustomSqlData] = useState(['', '', '', '', '']);

  const [chatData, setChatData] = useState([]);

  const [chatDataShowMore, setChatDataShowMore] = useState([]);

  const [stepLoader, setStepLoader] = useState(false);

  const [openNewProjectDialog, setOpenNewProjectDialog] = useState(false);

  const [openEditProjectDialog, setOpenEditProjectDialog] = useState(false);

  const [openEditAssetDialog, setOpenEditAssetDialog] = useState(false);

  const [openNewAssetDialog, setOpenNewAssetDialog] = useState(false);

  const [defaultAssetName, setDefaultAssetName] = useState('');

  const [restoreAssetData, setRestoreAssetData] = useState({});

  const [openNewProgramProjectDialog, setOpenNewProgramProjectDialog] = useState(false);

  const [isToasterMessageOpen, setIsToasterMessageOpen] = useState(false);

  const [toasterType, setToasterType] = useState('');

  const [toasterMessage, setToasterMessage] = useState('');

  const [userRoleDetails, setUserRoleDetails] = useState();

  const [currProcessId, setCurrProcessId] = useState();

  const [signedUploadURL, setSignedUploadURL] = useState();

  const [uploadStatusDetails, setUploadStatusDetails] = useState([]);

  const [isOpenUploadNotification, setIsOpenUploadNotification] = useState(false);

  const [openTabularStepOneDialog, setOpenTabularStepOneDialog] = useState({
    value: false,
    isFromNotification: false,
  });

  const [openTabularStepTwoDialog, setOpenTabularStepTwoDialog] = useState(false);

  const [tabularStepTwoResponse, setTabularStepTwoResponse] = useState({});

  const [openDocumentDataModal, setOpenDocumentDataModal] = useState({
    value: false,
    isFromNotification: false,
  });

  const [openFileUploadExplorer, setOpenFileUploadExplorer] = useState(false);

  const [disabledUploadDataBtn, setDisabledUploadDataBtn] = useState(false);

  const [selectedFileType, setSelectedFileType] = useState('');

  const [documentDataStepResponse, setDocumentDataStepResponse] = useState({});

  const [fileTypeFromSocket, setFileTypeFromSocket] = useState('');

  const [fileNameFromSocket, setFileNameFromSocket] = useState('');

  const [dataRepoTabValue, setDataRepoTabValue] = useState(0);

  const [editRowId, setEditRowId] = useState(0);

  const [tabularData, setTabularData] = useState([]);

  const [documentData, setDocumentData] = useState([]);

  const [selectedSearch, setSelectedSearch] = useState(null);

  const [selectedSearchType, setSelectedSearchType] = useState(null);

  const [goToDataLocationFromNotification, setGoToDataLocationFromNotification] =
    useState(false);

  const [ongoiningAssetReports, setOngoiningAssetReports] = useState([]);

  const [ongoiningProjectReports, setOngoiningProjectReports] = useState([]);

  const [currentUploadXhr, setCurrentUploadXhr] = useState(null);

  const [isFetchingSignedUrl, setIsFetchingSignedUrl] = useState(false);

  const [calcelUploadModalOpen, setCancelUploadModalOpen] = useState(false);

  const [ongoiningTabularDownloads, setOngoiningTabularDownloads] = useState([]);

  const [ongoiningDocumentDownloads, setOngoiningDocumentDownloads] = useState([]);

  const refreshTokenIfExpired = async () => {
    const user = auth.currentUser;
    if (user) {
      const refreshedToken = await getIdToken(user);
      localStorage.setItem('token', refreshedToken);
      return refreshedToken;
    }
    return null;
  };

  return (
    <AppStateContext.Provider
      value={{
        apiResponse,
        setApiResponse,
        chatLoader,
        setChatLoader,
        currConvId,
        setCurrConvId,
        customSqlData,
        setCustomSqlData,
        chatData,
        setChatData,
        chatDataShowMore,
        setChatDataShowMore,
        stepLoader,
        setStepLoader,
        openNewProjectDialog,
        setOpenNewProjectDialog,
        openEditProjectDialog,
        setOpenEditProjectDialog,
        openEditAssetDialog,
        setOpenEditAssetDialog,
        openNewAssetDialog,
        setOpenNewAssetDialog,
        defaultAssetName,
        setDefaultAssetName,
        restoreAssetData,
        setRestoreAssetData,
        openNewProgramProjectDialog,
        setOpenNewProgramProjectDialog,
        isToasterMessageOpen,
        setIsToasterMessageOpen,
        toasterType,
        setToasterType,
        toasterMessage,
        setToasterMessage,
        userRoleDetails,
        setUserRoleDetails,
        isOpenUploadNotification,
        setIsOpenUploadNotification,
        uploadStatusDetails,
        setUploadStatusDetails,
        currProcessId,
        setCurrProcessId,
        signedUploadURL,
        setSignedUploadURL,
        refreshTokenIfExpired,
        openTabularStepOneDialog,
        setOpenTabularStepOneDialog,
        openTabularStepTwoDialog,
        setOpenTabularStepTwoDialog,
        tabularStepTwoResponse,
        setTabularStepTwoResponse,
        goToDataLocationFromNotification,
        setGoToDataLocationFromNotification,
        customLegendConfig,
        setCustomLegendConfig,
        isCustomLegendOpen,
        setIsCustomLegendOpen,
        openFileUploadExplorer,
        setOpenFileUploadExplorer,
        disabledUploadDataBtn,
        setDisabledUploadDataBtn,
        selectedFileType,
        setSelectedFileType,
        openDocumentDataModal,
        setOpenDocumentDataModal,
        documentDataStepResponse,
        setDocumentDataStepResponse,
        setFileTypeFromSocket,
        fileTypeFromSocket,
        setFileNameFromSocket,
        fileNameFromSocket,
        dataRepoTabValue,
        setDataRepoTabValue,
        ongoiningAssetReports,
        setOngoiningAssetReports,
        ongoiningProjectReports,
        setOngoiningProjectReports,
        setEditRowId,
        editRowId,
        setTabularData,
        tabularData,
        setDocumentData,
        documentData,
        currentUploadXhr,
        setCurrentUploadXhr,
        setSelectedSearch,
        selectedSearch,
        setSelectedSearchType,
        selectedSearchType,
        isFetchingSignedUrl,
        setIsFetchingSignedUrl,
        calcelUploadModalOpen,
        setCancelUploadModalOpen,
        ongoiningTabularDownloads,
        setOngoiningTabularDownloads,
        ongoiningDocumentDownloads,
        setOngoiningDocumentDownloads,
      }}
    >
      {children}
    </AppStateContext.Provider>
  );
};

export const AppStateContextConsumer = AppStateContext.Consumer;

export function useAppState() {
  return useContext(AppStateContext);
}
